import { useApolloClient } from '@apollo/client'
import { useGraphqlFetchAndCache } from '@mostrans/web-components/hooks/useGraphqlFetchAndCache'
import { MasterDivisiAtom } from './DivisiAtoms'
import { getMasterDivision } from './DivisiQueries'

export const useGetMasterDivisi = () => {
    const client = useApolloClient()
    return useGraphqlFetchAndCache({
        atom: MasterDivisiAtom,
        initialValue: [],
        getData: () => getMasterDivision(client),
        variables: {}
    })
}
